import React from "react";
import data from "../../Json/Aboutpage/visionmission.json";
const VisionMission = () => {
  return (
    <div className="w-full my-10 ">
      <div className=" 2xl:container mx-auto   lg:px-20 md:px-10 px-6 flex justify-center gap-6">
        <div className="w-full xl:w-[90%]  flex flex-col lg:flex-row lg:justify-between bg-gray border-visionborder border rounded-[32px]">
        <div className="flex justify-center max-lg:w-full bg-white rounded-[32px] items-center">
          <img className="lg:max-w-[416px] max-h-[540px] rounded-[32px]" src={process.env.PUBLIC_URL + data.img} />
        </div>
        <div className="w-full p-10 ">
          <div className="flex flex-col gap-3 lg:gap-6">
            <h4 className="font-semibold text-20 md:text-24 text-aboutblack">
              {data.Title}
            </h4>
            <p className="text-16 md:text-18 text-aboutpara ">{data.para1}</p>
            <p className="text-16 md:text-18 text-aboutpara">{data.para2}</p>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default VisionMission;